import { useFormContext } from 'react-hook-form';

import { DynamicFormControl } from '@/components/DynamicFormControl';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import DynamicFormField from '../../DynamicFormField';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import { shouldShowNewCertificateFields } from '../authenticationVisibility.utils';

/**
 * New certificate fields component.
 * Renders dynamic form fields for generating a new certificate.
 * Shown during New mode or when regenerating in Edit mode.
 */
const NewCertificateFields = () => {
  const { formState } = useFormContext();
  const { errors } = formState;

  const {
    mode,
    connectionInputSchema,
    selectedSourceTypeId,
    authenticationMode,
    newCertificate,
    regenerateCertificate,
    isResettingSourceType
  } = useCloudSourceForm();

  if (isResettingSourceType) return null;

  if (
    !shouldShowNewCertificateFields(
      mode,
      authenticationMode,
      newCertificate,
      regenerateCertificate,
      connectionInputSchema
    )
  ) {
    return null;
  }

  return (
    <>
      {connectionInputSchema?.new_certificate_inputs?.map((d) => (
        <DynamicFormField
          formField={d}
          key={`${selectedSourceTypeId}-${d.name}`}
          xs={12}
          sm={6}
          md={4}
        >
          <DynamicFormControl {...d} />
          {errors[d.name] && <ErrorMessage message={errors[d.name]?.message} />}
        </DynamicFormField>
      ))}
    </>
  );
};

export default NewCertificateFields;
